import React, { useCallback, useEffect, useState } from 'react';

import BobLoadingMask from '../../../components/BobLoadingMask';

import { connect } from 'react-redux';

import { Grid, getSelectedState, GridColumn as Column } from '@progress/kendo-react-grid';
import { getter } from '@progress/kendo-react-common';
import { orderBy } from '@progress/kendo-data-query';

/*import SensorTypeTableContextMenu from './SensorTypeTableContextMenu';*/

import * as classes from './Table.module.css';

const idGetter = getter('id');

const SensorTypeTable = ({
    refreshTab,
    setRefreshTab,
    searchTerm,
    sensorTypes,
    ...props
}) => {
    const [skip, setSkip] = useState(0);
    const [take, setTake] = useState(50);
    const [pageable] = useState({ pageSizes: [10, 20, 50], info: true });
    const [sort, setSort] = useState([]);
    const [dataState, setDataState] = useState(
        sensorTypes.map((dataItem) =>
            Object.assign(
                {
                    selected: false,
                },
                dataItem
            )
        )
    );
    const [selectedState, setSelectedState] = useState({});

    useEffect(() => {
        setDataState(sensorTypes.filter(item => item.name.includes(searchTerm)).map((dataItem) =>
            Object.assign(
                {
                    selected: false,
                },
                dataItem
            )
        ));
    }, [searchTerm]);

    useEffect(() => {
        if (sensorTypes) setDataState(sensorTypes.map((dataItem) =>
            Object.assign(
                {
                    selected: false,
                },
                dataItem
            )
        ));
    }, [sensorTypes]);

    useEffect(() => {
        const refresh = async () => {
            setDataState(sensorTypes.filter(item => item.name.includes(searchTerm)).map((dataItem) =>
                Object.assign(
                    {
                        selected: false,
                    },
                    dataItem
                )
            ));
            setTimeout(() => {
                setRefreshTab();
            }, 750);
        };

        if (refreshTab) refresh();
    }, [refreshTab]);

    const onHeaderSelectionChange = useCallback((event) => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const newSelectedState = {};
        dataState.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
        });
        setSelectedState(newSelectedState);
    }, [dataState]);

    const onSelectionChange = React.useCallback(
        (event) => {
            const newSelectedState = getSelectedState({
                event,
                selectedState: selectedState,
                dataItemKey:   'id',
            });
            setSelectedState(newSelectedState);
        },
        [selectedState]
    );

    //const actionsCell = props => {
    //    return (
    //        <td>
    //            <SensorTypeTableContextMenu />
    //        </td>
    //    );
    //};

    const handlePageChange = async event => {
        setSkip(event.page.skip);
        setTake(event.page.take);
    };

    return (
        <div className={classes.Table}>
            <Grid
                sortable
                sort={sort}
                onSortChange={(e) => {
                    setSort(e.sort);
                }}
                className={classes.KendoGrid}
                data={orderBy(dataState, sort).slice(skip, take + skip).map((item) => ({
                    ...item,
                    'selected': selectedState[idGetter(item)],
                }))}
                dataItemKey="id"
                selectedField="selected"
                selectable={{
                    enabled: true,
                    drag:    false,
                    cell:    false,
                    mode:    'multiple'
                }}
                onSelectionChange={onSelectionChange}
                onHeaderSelectionChange={onHeaderSelectionChange}
                total={dataState.length}
                reorderable
                take={take}
                skip={skip}
                onPageChange={handlePageChange}
                pageable={pageable}
                pageSize={10}
            >
                <Column
                    field="selected"
                    width="70px"
                    headerSelectionValue={
                        dataState.length > 0 && dataState.findIndex((item) => !selectedState[idGetter(item)]) === -1
                    }
                />
                <Column
                    field="name"
                    title="Sensor Type"
                    width="auto"
                />
                {/*<Column*/}
                {/*    field=""*/}
                {/*    title=""*/}
                {/*    width="auto"*/}
                {/*    cell={actionsCell}*/}
                {/*/>*/}
            </Grid>
            {
                refreshTab === 'Sensor Types' ?
                    <BobLoadingMask />
                    :
                    null
            }
        </div>
    );
};

const mapStateToProps = state => ({
    sensorTypes: state.lookup.sensorTypes
});

export default connect(mapStateToProps, null)(SensorTypeTable);
